import React, { PureComponent } from 'react';
import styled from 'styled-components';
import onClickOutside from 'react-onclickoutside';

const StyledClickOutside = styled.div`
  display: flex;
  padding: 0 1em;
  align-self: stretch;
  align-items: center;
  color: ${p => p.theme.colors.aux.charcoal};
  ${p =>
    p.open &&
    p.label !== undefined &&
    `box-shadow: 0px 0px 2px ${p.theme.colors.aux.darkGrey};
     background: ${
       p.darkmode ? p.theme.colors.aux.charcoal : p.theme.colors.aux.white
     }; 
    `};
`;

class ClickOutsideComponent extends PureComponent {
  handleClickOutside = e => {
    this.props.onClickOutside(e);
  };
  render() {
    return (
      <StyledClickOutside
        open={this.props.open}
        label={this.props.label}
        darkmode={this.props.darkmode}
      >
        {this.props.children}
      </StyledClickOutside>
    );
  }
}

export default onClickOutside(ClickOutsideComponent);
